import React from 'react'

export const About = () => {
    return (
        <div>
            <h1>This is the about component</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo quae distinctio provident vero rerum expedita earum eius sint quos dolorum illum temporibus quidem in ipsa, ad beatae, repudiandae facilis aliquid?</p>
        </div>
    )
}